export default {
    /*
     * Checks whether the value for the element is present. options -
     * message
     */
    presence : function(element, options) {
        if (/^\s*$/.test(element.value || "")) {
            return options.message;
        }
    },

    depends : function(element, options) {
        // TODO dont use jquery
        var dependsVal = $('input:radio[name='+options.depends_on+']:checked').val();
        if(dependsVal == "true") {
            return;
        } else {
            return options.message;
        }
    },
    /*
     * Checks whether the input value matches defined format options -
     * message with => format the input value should match without =>
     * format the input value should not match
     */
    format : function(element, options) {
        if (options['with']) {
            var regex = new RegExp(options['with'], options['modifiers']);
            if(!regex.test(element.value)) {
                return options.message;
            }
        }
    },
    /*
     * Checks whether the input value contains only alphabets options -
     * message
     */
    alpha : function(element, options) {
        if(!(/^[A-Za-z]+$/.test(element.value))) {
            return options.message;
        }
    },
    /*
     * Checks whether the input value contains alphanumeric characters
     * options - message
     */
    alphaNumeric : function(element, options) {
        if(!(/^[0-9A-Za-z]+$/.test(element.value))) {
            return options.message;
        }
    },
    /*
     * Checks whether the input is a numeric value.
     * options  - message - message to show on error
     *          - strict_integer - true if strictly a integer without any decimals otherwise false
     *    - minimum - minimum value to compare with (inclusive)
     *    - maximum - maximum value to compare with (inclusive)
     */
    numeric : function(element, options) {
        if (!/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d*)?$/.test(element.value)) {
            return options.message;
        }
    },
    /*
     * Checks whether the value is strictly integer without any decimal values.
     * options - message
     */
    strictInt : function(element, options) {
        if (!/^\d+$/.test(element.value)) {
            return options.message;
        }
    },
    /*
     * Check the range of the input value.
     * options - message
     *         - minimum - the minimum value excluded
     *         - maximum - the maximum value included
     */
    range : function(element, options) {
        if(options.minimum && parseFloat(element.value) < options.minimum) {
            return options.message;
        }
        if(options.maximum && parseFloat(element.value) > options.maximum) {
            return options.message;
        }
    },
    /*
     * Check the length of the input value options - message
     * options - message
     *       - is - length should be exactly equal to
     *       - minimum - the minimum length of the field value
     *       - maximum - the maximum value of the field value
     */
    length : function(element, options) {
        if(options.is && element.value.length != options.is) {
            return options.message;
        }
        if(options.minimum && element.value.length < options.minimum) {
            return options.message;
        }
        if(options.maximum && element.value.length > options.maximum) {
            return options.message;
        }
    },

    email : function(element, options) {
        if(!(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i.test(element.value))) {
            return options.message;
        }
    },

    dateFormat : function(element, options) {
        if(Date.parseExact(element.value, options.format) == null) {
            return options.message;
        }
    },
    /*
     * Check whether the string passed is of currency format
     */
    money : function(element, options) {
        if(!(/^[\+|-]?[\d]+([\.][\d]{1,2})?$/.test(element.value))) {
            return options.message;
        }
    },

    allowNegative : function(element, options) {
        if(parseFloat(element.value < 0)) {
            return options.message;
        }
    },

    allowZero : function(element, options) {
        if(parseFloat(element.value == 0)) {
            return options.message;
        }
    },
    /*
     * Checks the validity of credit card.
     */
    luhnCheck : function(element, options)
    {
        var cc = element.value;
        var sum = 0;
        var numdigits = cc.length;
        var parity = numdigits % 2;
        for(var i=0; i < numdigits; i++) {
            var digit = parseInt(cc.charAt(i))
            if(i % 2 == parity) digit *= 2;
            if(digit > 9) digit -= 9;
            sum += digit;
        }
        if((sum % 10) != 0) {
            return options.message;
        }
    },
    /*
     * validates credit card number using jquery.payment.
     */
    cardNumber: function(element, options) {
        if (!$.payment.validateCardNumber(element.value)) {
            return options.message;
        }
    },
    /*
     * validates cvv based on card type using jquery.payment.
     * important : cvv field should have card number's field id as data-cb attribute.
     */
    cardCVV: function(element, options) {
        var cardNumber = document.getElementById(element.dataset.cbcard);
        if (typeof cardNumber == 'undefined' || cardNumber == '') {
            return;
        }
        var cardType = $.payment.cardType(cardNumber);
        if (!$.payment.validateCardCVC(element.value, cardType)) {
            return options.message;
        }
    },
    /*
     * validates card expiry using jquery.payment.
     */
    cardExpiry: function(element, options) {
        var monthElement = document.getElementById(element.dataset.monthElementId);
        if (!$.payment.validateCardExpiry(monthElement.value, element.value)) {
            return options.message;
        }
    }
}


// WEBPACK FOOTER //
// ./src/helpers/validators.js